function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useCallback, useContext, useLayoutEffect, useReducer } from 'react';
var FirstPaint = /*#__PURE__*/React.createContext(function (action) {
  return undefined;
});
export var initialState = {
  hasSent: false
};
export function reducer(state, action) {
  switch (action.type) {
    case 'reset':
      return initialState;

    case 'render':
      if (state.hasSent) {
        return state;
      } else if (state.trackedHeroElement && state.trackedHeroElement !== action.heroId) {
        console.warn("The current page is trying to track HeroElement \"".concat(action.heroId, "\", but is already tracking \"").concat(state.trackedHeroElement, "\".\n\n") + "First Meaningful Paint metric just really makes sense in case of single element per page, so \"".concat(action.heroId, "\" will be discarded.\n") + "You should remove or refactor this page so only a single element is tracked instead.\n\n" + "You can learn more about the FMP metric at: https://web.dev/first-meaningful-paint");
        return state;
      } else if (state.trackedHeroElement) {
        console.debug("The element ".concat(action.heroId, " was first rendered at ").concat(state.firstMeaningfulPaint, "s. Dropping duplicated metric."));
        return state;
      } else {
        var firstMeaningfulPaint = action.timestamp / 1000;
        console.log('[NewRelic] FMP:', firstMeaningfulPaint);

        if (action.interaction) {
          action.interaction.getContext(function (ctx) {
            ctx.firstMeaningfulPaint = firstMeaningfulPaint;
          });
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          node: action.node,
          trackedHeroElement: action.heroId,
          trackedHeroInteraction: action.interaction,
          firstMeaningfulPaint: firstMeaningfulPaint
        });
      }

    case 'interactionEnded':
      if (!state.trackedHeroElement) {
        console.warn("The current page has finished rendering but did not rendered any HeroElement. Possible causes includes:\n\n" + "* Custom NewRelic instrumentation interfering with \"Page load\" interaction.\n" + "* Your component relies on async work that takes longer than \"Page load\", and not beign correctly accounted there.\n" + "* The current page does not define any Hero element.\n\n" + "Please be sure to define a Hero element, more information can be found at HeroElement documentations.\n" + "If you want to know more about NewRelic Page loads, you can learn more at https://docs.newrelic.com/docs/browser/new-relic-browser/page-load-timing-resources/page-load-timing-process.");
      } else if (JSON.stringify(state.trackedHeroInteraction) !== JSON.stringify(action.interaction)) {
        console.warn("The current page has finished at a NewRelic interaction different from the one HeroElement rendered. Possible causes includes:\n\n" + "* Custom NewRelic instrumentation interfering with \"Page load\" interaction.\n" + "* Your component relies on async work that creates race conditions with NewRelic instrumentation.\n" + "Tracked interaction: %o, Current interaction: %o\n" + "If you want to know more about NewRelic Page loads, you can learn more at https://docs.newrelic.com/docs/browser/new-relic-browser/page-load-timing-resources/page-load-timing-process.", state.trackedHeroInteraction, action.interaction);
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        hasSent: true
      });

    default:
      return state;
  }
}
export var HeroElementContainer = function HeroElementContainer(props) {
  var _useReducer = useReducer(reducer, initialState, function (state) {
    return state;
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  useLayoutEffect(function () {
    if (window.newrelic) {
      var interaction = window.newrelic.interaction().onEnd(function (ctx) {
        interaction.setAttribute('podium.firstMeaningfulPaint', ctx.firstMeaningfulPaint);
        dispatch({
          type: 'interactionEnded',
          interaction: interaction
        });
      });
    }

    return function () {
      return dispatch({
        type: 'reset',
        interaction: window.newrelic ? window.newrelic.interaction() : null
      });
    };
  }, []);
  return /*#__PURE__*/React.createElement(FirstPaint.Provider, {
    value: dispatch
  }, props.children);
};
export function useHeroRef(props, context) {
  var dispatch = useContext(FirstPaint);
  var targetNode = useCallback(function (node) {
    if (node) {
      dispatch({
        type: 'render',
        heroId: props.heroId,
        node: node,
        interaction: window.newrelic ? window.newrelic.interaction() : null,
        timestamp: window.performance.now()
      });
    }
  }, [dispatch, props.heroId]);
  return targetNode;
}
export function HeroElement(props) {
  var heroRef = useHeroRef(props);

  var testId = props.testId,
      heroId = props.heroId,
      rest = _objectWithoutProperties(props, ["testId", "heroId"]);

  return /*#__PURE__*/React.createElement("div", _extends({
    ref: heroRef,
    "data-testid": testId !== null && testId !== void 0 ? testId : heroId,
    "data-fmp-id": heroId
  }, rest), props.children);
}